/**
 * ag-Grid set column filter entry (driver-schedule grids).
 * Class (not interface) so emitDecoratorMetadata can resolve @Input types at runtime.
 */
export class DriverScheduleSetFilterDef {
  filterType: string;
  values: string[];
}

/** Full filter model for driver-schedule ag-Grid columns. */
export class DriverScheduleFilterModel {
  vehicle?: DriverScheduleSetFilterDef;
  starttime?: DriverScheduleSetFilterDef;
  endtime?: DriverScheduleSetFilterDef;
  driverid?: DriverScheduleSetFilterDef;
  driver?: DriverScheduleSetFilterDef;
  location?: DriverScheduleSetFilterDef;
}

export class DriverScheduleSortModel {
  colId: string;
  sort: string;
}

export type DriverScheduleScheduleFilterColumnKey =
  'vehicle' | 'starttime' | 'endtime' | 'driverid' | 'driver';

export type DriverScheduleResourcesFilterColumnKey =
  'vehicle' | 'starttime' | 'endtime';

export type DriverScheduleFilterColumnKey =
  DriverScheduleScheduleFilterColumnKey | DriverScheduleResourcesFilterColumnKey | 'location';

const SCHEDULE_GRID_FILTER_KEYS: DriverScheduleScheduleFilterColumnKey[] = [
  'vehicle',
  'starttime',
  'endtime',
  'driverid',
  'driver'
];

const RESOURCES_GRID_FILTER_KEYS: DriverScheduleResourcesFilterColumnKey[] = [
  'vehicle',
  'starttime',
  'endtime'
];

export function sliceScheduleGridFilterModel(
  model: DriverScheduleFilterModel
): DriverScheduleFilterModel {
  return sliceDriverScheduleFilterModel(model || {}, SCHEDULE_GRID_FILTER_KEYS);
}

export function sliceResourcesGridFilterModel(
  model: DriverScheduleFilterModel
): DriverScheduleFilterModel {
  return sliceDriverScheduleFilterModel(model || {}, RESOURCES_GRID_FILTER_KEYS);
}

function sliceDriverScheduleFilterModel(
  model: DriverScheduleFilterModel,
  keys: DriverScheduleFilterColumnKey[]
): DriverScheduleFilterModel {
  if (!model) {
    return {};
  }
  const slice = new DriverScheduleFilterModel();
  keys.forEach((key: DriverScheduleFilterColumnKey) => {
    const entry = model[key];
    if (entry != null) {
      slice[key] = entry;
    }
  });
  return slice;
}

export function driverScheduleFilterSlicesEqual(
  a: DriverScheduleFilterModel,
  b: DriverScheduleFilterModel
): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function toDriverScheduleFilterModel(value: Object): DriverScheduleFilterModel {
  if (!value || typeof value !== 'object') {
    return new DriverScheduleFilterModel();
  }
  return Object.assign(new DriverScheduleFilterModel(), value);
}



// WEBPACK FOOTER //
// ./src/app/pages/driver-schedule/driver-schedule-filter.model.ts